export default __webpack_public_path__ + "static/media/Snd_C1.67092202.mp3";